export default {"src":"/_next/static/media/mode_online.32c61ddd.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};